import { AbstractBulkFetch } from '../bulkFetch/abstractBulkFetch.service';
import httpService from '../http/http.service';
import KeyBy from 'lodash-es/keyBy';
import { CharacterStatisticViewObject, CharacterStatisticViewModel, MultiRealmSpecificRequest } from '@/types/apiServerContract';

class CharacterStatistics extends AbstractBulkFetch<CharacterStatisticViewObject> {
    constructor(protected controller: string) {
        super(controller);
    }

    protected async apiCall(ids: number[]): Promise<{ [key: number]: CharacterStatisticViewObject }> {
        const result = await httpService.Post<CharacterStatisticViewModel>(this.getUrl('GetCharacterStatistics'), {
            realmIds: ids
        } as MultiRealmSpecificRequest);
        return KeyBy<CharacterStatisticViewObject>(result.characterStatistics, 'realmId');
    }
}

export default class StatisticsService {
	public static GetCharacterStatistics = new CharacterStatistics('statistics');
}
